import React, { FC, useEffect } from 'react';
import { create } from 'zustand';
import { DropdownDefinition } from '~/training/sequence/templates/items';

export interface QuizDropdownStore {
  items: Array<DropdownDefinition>;
  pushItem: (item: DropdownDefinition) => void;
  useItem: (item?: string) => void;
  unUseItem: (item?: string) => void;
}

const _useQuizDropdownStore = create<QuizDropdownStore>(set => ({
  items: [],
  pushItem: item =>
    set(s => {
      item.used = false;
      s.items.push(item);
      return { items: s.items };
    }),
  useItem: label =>
    set(s => {
      const newItems = s.items.map((itemElement: DropdownDefinition) => {
        if (itemElement.label == label) {
          itemElement.used = true;
        }
        return itemElement;
      });
      return { items: newItems };
    }),
  unUseItem: label =>
    set(s => {
      const newItems = s.items.map((itemElement: DropdownDefinition) => {
        if (itemElement.label == label) {
          itemElement.used = false;
        }
        return itemElement;
      });
      return { items: newItems };
    })
}));

export const QuizDropdownProvider: FC = ({ children }) => {
  useEffect(() => {
    useQuizDropdownStore.setState({items: []});
  }, []);
  return <>{children}</>
};

export const useQuizDropdownStore = _useQuizDropdownStore;
